import App from './App'
import Vue from 'vue'
import router from './router'
import store from './vuex/state'
import axios from 'axios'
import config from '@/conf'


import VueLazyLoad from 'vue-lazyload';
Vue.use(VueLazyLoad,{
  error:'./static/img/lazyload_fail.png',
  loading:'./static/img/lazyload.png',
  attempt:3
})

axios.defaults.baseURL = `${config.router}`;
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  // var epoqueToken = sessionStorage.getItem('epoqueToken');
  if( localStorage.epoqueToken){
    config.headers['X-epoque-mall-Authorization']=JSON.parse(localStorage.epoqueToken).content;
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  if(response.data.error_code&&(response.data.error_code==10001||response.data.error_code==10002)){
    localStorage.removeItem('epoqueToken')  //新加的
    location.reload(true);
  }
   return response;
}, function (error) {
  return Promise.reject(error);
});

Vue.config.productionTip = false
const vm=new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  mounted(){}
})



// WEBPACK FOOTER //
// ./src/main.js